// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.jsx";
// nodejs library that concatenates classes
import classNames from "classnames";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import React from "react";
// react component used to create nice image meadia player
import Link from "react-router-dom/Link";
import ApiClient from "../../services/api-client/ApiClient";
import SectionWork from "../QxQPublicPage/Sections/SectionWork";
import MapContainer from "./Partials/MapContainer";
import TranslationService from "../../services/translation/TransationService";
import QxQFooter from "../QxQPublicPage/Partials/QxQFooter";
// @material-ui/icons
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import RatingScoreCard from "../../components/RatingScoreCard/RatingScoreCard";

class QxQFacilityShowPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colorSelect: "0",
      sizeSelect: "0"
    };
  }

  handleSelect = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.title = `QxQ - ${TranslationService.get("HOME.TITLE")}`;
    ApiClient.facility.get(this.props.match.params.facilityId).then(result => {
      this.setState({
        facility: result.data.facility,
        lastAutoevaluation: result.data.lastAutoevaluation,
        relatedFacilities: result.data.relatedFacilities
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    ApiClient.facility.get(nextProps.match.params.facilityId).then(result => {
      this.setState({
        facility: result.data.facility,
        lastAutoevaluation: result.data.lastAutoevaluation,
        relatedFacilities: result.data.relatedFacilities
      });
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.productPage}>
        <Header
          brand="Material Kit PRO React"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
          color="transparent"
          changeColorOnScroll={{
            height: 100,
            color: "info"
          }}
        />
        <Parallax
          image={require("assets/img/facility_paralax.jpg")}
          filter="info"
          className={classes.pageHeader}
        />
        <div className={classNames(classes.section, classes.sectionGray)}>
          <div className={classes.container}>
            <div className={classNames(classes.main, classes.mainRaised)}>
              <GridContainer>
                <GridItem md={6} sm={6}>
                  <CardBody pricing style={{ textAlign: "center" }}>
                    <div
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxWidth: "320px"
                      }}
                    >
                      <h6
                        className={`${classes.cardDescription} ${
                          classes.marginBottom20
                        }`}
                        style={{ maxWidth: "320px", marginLeft: "-17px" }}
                      >
                        {this.state.facility ? (
                          <RatingScoreCard
                            scoreNumber={this.state.facility.score}
                            lastAutoevaluationDate={new Date(this.state.facility.lastAutoevaluationDate)}
                          />
                        ) : null}
                      </h6>
                    </div>
                    <h3
                      className={`${classes.cardTitle} ${classes.marginTop30}`}
                    >
                      {this.state.facility
                        ? this.state.facility.companyName
                        : null}
                    </h3>
                    <p className={classes.cardDescription}>
                      {this.state.facility ? this.state.facility.address : null}
                    </p>
                    <br/>

                    {
                      this.state.lastAutoevaluation && this.state.lastAutoevaluation.blocks ?
                        this.state.lastAutoevaluation.blocks.map(block => (
                          <p className={classes.cardDescription}>
                            {block[`score_${block.score}_text_${TranslationService.currentLangForScore()}`]}
                          </p>
                        )) : null
                    }

                    <p className={classes.cardDescriptionDisclaimer}>
                      {this.state.facility ? TranslationService.get('FACILITY.EXPLAINATION') : null}
                    </p>
                  </CardBody>
                  <GridContainer>
                    <GridItem md={6} sm={12}>
                      {this.state.facility ? (
                        <InfoArea
                          className={classes.infoArea}
                          title={TranslationService.get("FACILITY.ADDRESS")}
                          description={this.renderAdress()}
                          icon={PinDrop}
                        />
                      ) : null}
                    </GridItem>
                    <GridItem md={6} sm={12}>
                      {this.state.facility ? (
                        <InfoArea
                          className={classes.infoArea}
                          title={TranslationService.get("FACILITY.CONTACT")}
                          description={this.renderContact()}
                          icon={Phone}
                        />
                      ) : null}
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem md={6} sm={6} style={{ minHeight: "300px" }}>
                  {this.state.facility ? (
                    <MapContainer
                      lat={this.state.facility.latitude}
                      lng={this.state.facility.longitude}
                    />
                  ) : null}
                </GridItem>
              </GridContainer>
            </div>
            <div className={classes.relatedProducts}>
              <h3 className={classNames(classes.title, classes.textCenter)}>
                {TranslationService.get("FACILITY.RELATED")}
              </h3>
              <GridContainer>
                {this.state.relatedFacilities
                  ? this.state.relatedFacilities.map((facility, key) => {
                      return (
                        <GridItem key={key} xs={12} sm={6} md={4} lg={4}>
                          <Card pricing raised>
                            <CardBody pricing>
                              <div
                                style={{
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  maxWidth: "320px"
                                }}
                              >
                                <h6
                                  className={`${classes.cardDescription} ${
                                    classes.marginBottom20
                                  }`}
                                >
                                  {this.state.facility ? (
                                    <RatingScoreCard
                                      scoreNumber={facility.score}
                                      lastAutoevaluationDate={new Date(facility.lastAutoevaluationDate)}
                                    />
                                  ) : null}
                                </h6>
                              </div>
                              <h3
                                className={`${classes.cardTitle} ${
                                  classes.marginTop30
                                }`}
                              >
                                {facility.companyName}
                              </h3>
                              <p className={classes.cardDescription}>
                                {facility.address}
                              </p>
                              <Link to={"/facilities/" + facility.id}>
                                <Button round color="primary">
                                  MÁS INFO
                                </Button>
                              </Link>
                            </CardBody>
                          </Card>
                        </GridItem>
                      );
                    })
                  : null}
              </GridContainer>
            </div>
          </div>
        </div>
        <div className={classes.container}>
          <SectionWork />
        </div>
        <QxQFooter classes={classes} />
      </div>
    );
  }

  renderAdress() {
    return (
      <span>
        {this.state.facility.address},
        {this.state.facility.city ? (
          <div>
            {this.state.facility.city}, {this.state.facility.zipcode}
          </div>
        ) : null}
        {this.state.facility.province ? (
          <div>{this.state.facility.province}</div>
        ) : null}
        {this.state.facility.country ? (
          <div>{this.state.facility.country}</div>
        ) : null}
      </span>
    );
  }

  renderContact() {
    return (
      <span>
        {this.state.facility.phone ? (
          <div>{this.state.facility.phone}</div>
        ) : null}
        <h3>
          {this.state.facility.instagram ? (
            <a
              target="_blank"
              href={this.state.facility.instagram}
              style={{ marginRight: "5px" }}
            >
              <i className="fab fa-instagram" />
            </a>
          ) : null}
          {this.state.facility.twitter ? (
            <a
              target="_blank"
              href={this.state.facility.twitter}
              style={{ marginRight: "5px" }}
            >
              <i className="fab fa-twitter" />
            </a>
          ) : null}
          {this.state.facility.facebook ? (
            <a
              target="_blank"
              href={this.state.facility.facebook}
              style={{ marginRight: "5px" }}
            >
              <i className="fab fa-facebook" />
            </a>
          ) : null}
          {this.state.facility.web ? (
            <a
              target="_blank"
              href={this.state.facility.web}
              style={{ marginRight: "5px" }}
            >
              <i className="fas fa-globe" />
            </a>
          ) : null}
        </h3>
      </span>
    );
  }
}

export default withStyles(productStyle)(QxQFacilityShowPage);



// WEBPACK FOOTER //
// ./src/views/QxQFacilityShowPage/QxQFacilityShowPage.jsx